import React from 'react'
import Modal from 'react-modal'
import styles from './../LinkDocumentModal.scss'
import cs from 'classnames'
import nesProp from 'nested-property'
import { connect } from 'react-redux'
import i18n from 'lib/i18n'
import { Table, Thead, Th, Tr, Td, collapseTd } from 'components/reactable'
import { fetchClient, uploadReadyDocuments, updateManyDocuments, getOneDsPackageById } from '../../../state/actions'
import CustomSelect from './../DSWizardHelper'
import * as c from 'state/constants'
import {HALF_FILLED_PDF_API_URL} from './../DSWizard'

const _ = i18n('dsdocuments')

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
        overflow: 'visible'
    },
    content: {
        position: 'relative',
        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
        maxHeight: '90%',
        //minHeight: '50%',
        overflow: 'visible',
        padding: '0',
        wordWrap: "break-word"
    },
}

const CONNECTIVE_ERROR = 'CONNECTIVE_ERROR'
const NO_DOCUMENT_FOUND_ON_SERVER = 'NO_DOCUMENT_FOUND_ON_SERVER'
const NO_DOCUMENTS_AVAILABLE_FOR_PROCESS = 'NO_DOCUMENTS_AVAILABLE_FOR_PROCESS'
const UPLOAD_TO_ORACLE_TIMEOUT = 'UPLOAD_TO_ORACLE_TIMEOUT'
const NO_DOCUMENT_MATCH_FOR_UPLOAD = 'NO_DOCUMENT_MATCH_FOR_UPLOAD'
const MISSING_ARGUMENTS = 'MISSING_ARGUMENTS'

/**
 * Connect module to store
 */
@connect(
    (state) => ({
        client: nesProp.get(state, "DSDocuments.client"),
        lang: nesProp.get(state, 'app.lang')
    })
)
export default class LinkDocumentsModal extends React.Component {
    static propTypes = {
        modalIsOpen: React.PropTypes.bool,
        onCancel: React.PropTypes.func,
        onConfirmation: React.PropTypes.func,
        options: React.PropTypes.object,
        payload: React.PropTypes.object
    }

    constructor(props) {
        super(props)

        const payload = nesProp.get(props, "payload")
        const dsPackage = nesProp.get(payload, "dsPackage")
        let clientId = dsPackage ? nesProp.get(payload, 'dsPackage.clientId') : ''

        //this.handleKeyPress = this.handleKeyPress.bind(this);
        this.state = {
            contractNumbersOptions: [],
            contractsNumberHashmap: {},
            isLoaded: true,
            clientLoaderAlreadyStarted: false,
            isValidTheForm: false,
            formInputs: {},
            clientId,
            step: 1,
            dsPackage,
            wizardError: false,
            dsDocumentsThatRequireLinking: [],
            selectedDsDocumentIds: [],
            linkedDocuments: []
        }
    }

    /**
     * Default hook for unmounting component
     */
    componentWillUnmount() {
        this.clearModule()
    }

    /**
     * Default hook for processing if something in props was changed
     * @param {*} nextProps
     * @returns
     */
    componentWillReceiveProps(nextProps) {
        // incoming values from outside module, or from the store
        const payload = nesProp.get(nextProps, "payload")
        const client = nesProp.get(nextProps, "client")
        let newPropsDsPackage = nesProp.get(payload, "dsPackage")
        let dsPackage = newPropsDsPackage

        let clientId = nesProp.get(dsPackage, "clientId")

        // old values, mostly only for compare to detect if something was changed
        const oldDsPackage = nesProp.get(this, "props.payload.dsPackage")
        let shouldReinitializeTheModule = false
        let willClientChange = clientId !== this.state.clientId

        // -----------------------------------------------------------------
        // --------------------- processing section ------------------------
        // detect client change
        if (willClientChange) {
            // enable initialization
            shouldReinitializeTheModule = true

            // if the client id is empty then abort the wizard
            if (!clientId) {
                return this.clearModule()
            }
        }
        //detect package change
        let willDsPackageChange = (dsPackage && !!oldDsPackage) || (dsPackage && oldDsPackage && (String(dsPackage._id) !== String(oldDsPackage._id)))

        // detect document change
        if (willDsPackageChange) {
            // enable initialization
            shouldReinitializeTheModule = true
        }

        // if there is something changed what affect the module settings, then must reinitialize.
        if (shouldReinitializeTheModule) {
            this.setState({ clientId, dsPackage })
            this.initModule(clientId, client, dsPackage)
        }
        // -------------------- end of update props processing ----------------

        // everything is up to date, nothing to do here
        return true
    }

    componentDidMount() {
        // document.body.addEventListener('keyup', this.props.onCancel, false)
        let { client, payload } = this.props
        let { clientId, dsPackage } = this.state

        this.initModule(clientId, client, dsPackage)
    }

    /**
     * Reset the module, for a new client and document
     */
    clearModule() {
        this.setState({
            contractNumbersOptions: [],
            contractsNumberHashmap: {},
            isLoaded: true,
            clientLoaderAlreadyStarted: false,
            isValidTheForm: false,
            formInputs: {},
            step: 1,
            wizardError: false,
            dsDocumentsThatRequireLinking: [],
            selectedDsDocumentIds: [],
            linkedDocuments: []
        })
    }

    /**
     * Component did mount hook. Check and load all the dependency values, init related values.
     */
    async initModule(clientId, client, dsPackage) {
        try {
            const { dispatch } = this.props
            const { contractNumbersOptions, dsDocumentsThatRequireLinking } = this.state
            let areThereContractNumberOptions = (contractNumbersOptions && (contractNumbersOptions.length > 0))
            let isChangedTheClientId = ((client && (client.clientId !== clientId)) || !client)

            // // determine if is needed to link a contract or anything, if not the skip the first step
            if (!dsPackage) {
                return
            }
            // if no contract required, jump the first step
            if (!dsPackage.requireLinking) {
                this.setState({ isLoaded: true, wizardError: false })
                this.setState({ clientLoaderAlreadyStarted: false })

                return this.setState({ step: 2 })
            }

            this.setState({ isLoaded: false })
            this.setState({ clientLoaderAlreadyStarted: false })
            // reset step to step 1 because must linked the contract number
            this.setState({ step: 1 })

            if (dsPackage && (!dsDocumentsThatRequireLinking || dsDocumentsThatRequireLinking.length === 0)) {
                const newDsDocumentsThatRequireLinking = dsPackage.dsDocuments.filter(oneDocument => oneDocument.documentTemplate && oneDocument.documentTemplate.uploadedOnModule === "DS_MODULE_CLIENT_CONTRACT" && !oneDocument.contractId)
                this.setState({ dsDocumentsThatRequireLinking: newDsDocumentsThatRequireLinking })
            }

            if (((!areThereContractNumberOptions && !this.state.clientLoaderAlreadyStarted) || isChangedTheClientId) && clientId) {
                this.setState({ clientLoaderAlreadyStarted: true })
                const fetchClientResult = await dispatch(fetchClient(clientId))

                let { client } = fetchClientResult
                let { contracts } = client
                let contractNumbersOptions = this.getContractNumbersInOptionList(contracts)
                let contractsNumberHashmap = this.getContractsHashmap(contractNumbersOptions)
                this.setState({ clientLoaderAlreadyStarted: false })
                this.setState({ contractNumbersOptions, contractsNumberHashmap, wizardError: false }, () => { })

            } else {
                if (!areThereContractNumberOptions && !this.state.clientLoaderAlreadyStarted && client) {
                    let { contracts } = client
                    let contractNumbersOptions = this.getContractNumbersInOptionList(contracts)
                    let contractsNumberHashmap = this.getContractsHashmap(contractNumbersOptions)
                    this.setState({ contractNumbersOptions, contractsNumberHashmap }, () => { resolve() })
                }
            }

            // init form inputs, and values
            const oneDocument = (dsDocumentsThatRequireLinking && dsDocumentsThatRequireLinking[0]) ? dsDocumentsThatRequireLinking[0] : ''
            let formInitialValues = this.getFormInitialValues(oneDocument)
            let formInputs = this.formInputFieldsList(formInitialValues)

            this.setState({ formInputs }, () => {
                // reset the flag of form validity
                this.setFormValidityFlag()
                this.setState({ isLoaded: true })
            })
        } catch (err) {
            console.warn("promises err", err)
            this.setState({ clientLoaderAlreadyStarted: false, wizardError: (err && err.message || JSON.stringify(err)) })
        }

    }

    /**
     * This function prepare and return a bunch of predefined data for the form inputs indexed by form input ref names
     */
    getFormInitialValues(dsDocument) {

        let initialValues = {
            "contractNumber": nesProp.get(dsDocument, "contractNumber"),
        }

        return initialValues
    }

    /**
     * One input field basic props for handle form.
     */
    _inputPrototype() {
        return { label: "", value: "", touched: false, error: false, isRequired: false, isValid: () => (true), errorMessage: _("invalidInputValue") }
    }

    /**
     * Copy one input handler object and return.
     */
    _initValueOfInput() {
        let proto = JSON.parse(JSON.stringify(this._inputPrototype()))
        proto.isValid = () => (true) // JSON trick is not perfect to copy an object :)
        return proto
    }

    /**
     * Compose and setup the form inputs with validation an custom error messages
     * @param {*} formInitialValues - initial values for the form.
     */
    formInputFieldsList(formInitialValues) {
        return {
            "contractNumber": {
                ...(this._initValueOfInput()),
                isRequired: true,
                errorMessage: _("invalidContractNumber"),
                value: nesProp.get(formInitialValues, "contractNumber")
            }
        }
    }

    /**
     * Get all of the client contract numbers in a list what is digestible for react select.
     */
    getContractNumbersInOptionList(contracts) {
        let result = []

        if (!contracts || contracts.length === 0) {
            return result
        }

        let objKeys = Object.keys(contracts)
        result = objKeys && objKeys.map((oneKey) => {
            let contractNumber = nesProp.get(contracts, oneKey + ".contractMain.contractNumber")
            let contractMainBranch = nesProp.get(contracts, oneKey + ".contractMain.mainBranche")
            let contractMainRisk = nesProp.get(contracts, oneKey + ".contractMain.mainRisk")
            let contractCompany = nesProp.get(contracts, oneKey + ".contractMain.insuranceCompany")
            let contractId = nesProp.get(contracts, oneKey + ".contractMain.contractId")

            return {
                label: contractNumber + " - " + contractMainBranch + " - " + contractMainRisk + " - " + contractCompany,
                value: contractNumber,
                contractId: contractId
            }
        })

        return result
    }

    /**
     * Get contractNumber indexed contractId list.
     */
    getContractsHashmap(contractNumbersOptions) {
        let result = {}

        if (!contractNumbersOptions || contractNumbersOptions.length === 0) {
            return result
        }

        contractNumbersOptions.forEach((oneContractOption) => {
            result[oneContractOption.value] = oneContractOption.contractId
        })

        return result
    }

    /**
     * This function helps to find by a input-select-value a full element from options, so a value-label pair.
     * This is necessary for react select 2 to display the label of the selected option after selection in dropdown list.
     * @param {*} value
     * @param {*} options
     */
    findItemByValueFromSelectOptions(value, options) {
        let result = { label: value, value: value }

        if (!options) {
            return result
        }

        let filteredByValue = options.filter((item) => {
            return item.value === value
        })

        // if no result in list of options the result the subject value
        if (!filteredByValue || filteredByValue.length === 0) {
            return result
        }

        // in case of match then the first match is the selected one. If there are no values then remains the subject value
        return nesProp.get(filteredByValue, "0") || result
    }

    /**
     * Change one input value in state, validate also.
     */
    onChangeFormInput(value, formFieldName, forceTouch = null, callback = () => { }) {
        const { formInputs } = this.state
        //const data = this.fetchFormValues()

        //get the object from state to be able to set the validity value in it.
        let formField = nesProp.get(formInputs, formFieldName)

        // handle touch input
        if (formField.value !== value && (forceTouch === null)) {
            formField.touched = true
        }

        if (forceTouch !== null) {
            formField.touched = forceTouch
        }

        // set the value
        formField.value = value

        // set the validity in object, this will be set because it passed by address in JS
        formField = this.fieldValidation(formField)

        // this wil set back the value but implemented only for to be understandable, the value is set by address of object.
        nesProp.set(formInputs, formFieldName, formField)

        // put back into the state
        this.setState({ formInputs: formInputs }, () => {
            callback()
        })
    }

    /**
     * This function validate one field from the form.
     * @param {*} formField - instance of input field object
     * @param {*} inputValue - the new value of input
     * @param {*} forceTouch - touch anyway the input even if the value is not modified (useful on onBluer fired or onSubmit)
     */
    fieldValidation(formField, forceTouch = false) {
        // required check
        if (formField.isRequired && !formField.value) {
            formField.error = _("fieldRequired")
            formField.touched = forceTouch ? true : formField.touched
        } else {
            // validate if "isValid" property is set
            if (formField.isValid) {
                if (formField.isValid(formField.value)) {
                    formField.error = false
                } else {
                    formField.error = formField.errorMessage
                    formField.touched = forceTouch ? true : formField.touched
                }
            } else {
                formField.error = false
                formField.touched = forceTouch ? true : formField.touched
            }
        }

        // reset the flag of form validity
        this.setFormValidityFlag()

        return formField
    }

    /**
     * Reset the flag of form validity in state by checking the formInputs in state.
     */
    setFormValidityFlag() {
        const formInputs = nesProp.get(this, "state.formInputs")

        // every change must set the valid form
        if (formInputs) {
            let hasError = false
            let keys = Object.keys(formInputs) || []

            keys.forEach((oneKey) => {
                if (formInputs[oneKey].error) {
                    hasError = true
                }
            })

            this.setState({ isValidTheForm: (hasError ? false : true) })

            return hasError ? false : true
        }

        return true
    }


    /**
     * Fetch values from form by input refs
     */
    fetchFormValues() {
        const { formInputs } = this.state
        const formFieldNames = Object.keys(formInputs)
        let formData = {}

        formFieldNames.forEach((formFieldName) => {
            // react creatable select way to get value
            let formFieldValue = nesProp.get(this, "refs." + formFieldName + ".props.value.value")

            // if not then react select way to get value
            formFieldValue = formFieldValue || nesProp.get(this, "refs." + formFieldName + ".state.value.value")

            // if not then normal text input way to get value
            formFieldValue = formFieldValue || nesProp.get(this, "refs." + formFieldName + ".value")
            formData[formFieldName] = formFieldValue
        })

        //example: this values are not shown in the form, because are not editable only must pass forward fot create package
        // formData["someFieldName"] = nesProp.get(formInputs, "someFieldName.value")

        return formData
    }

    /**
     * Fill the form values ins state
     * @param {*} data
     * @param {*} formInputs
     *
     * @returns formInputs - reference to formInputs object in state
     */
    setFormInputsByFormValues(data, formInputs) {
        if (!formInputs) {
            return
        }

        const formInputNames = Object.keys(formInputs)
        formInputNames.forEach((formFieldName) => {

            let dataField = nesProp.get(data, formFieldName)
            let formField = nesProp.get(formInputs, formFieldName)

            formField.value = dataField

            // set back the value but this is already set by address, but must implement to see what happen
            // so if you delete this row don't prevent tha value change caused by fieldValidation. (Only the deep cloning of values can solve.)
            nesProp.set(formInputs, formFieldName, formField)
        })

        return formInputs
    }

    /**
     * Validate the hole form.
     * @param {*} data
     * @param {*} formInputs
     *
     * @returns formInputs - reference to formInputs object in state
     */
    formInputsValidation(formInputs, forceTouch = false) {
        if (!formInputs) {
            return
        }

        const formInputNames = Object.keys(formInputs)
        formInputNames.forEach((formFieldName) => {

            let formField = nesProp.get(formInputs, formFieldName)

            formField = this.fieldValidation(formField, forceTouch)

            // set back the value but this is already set by address, but must implement to see what happen
            // so if you delete this row don't prevent tha value change caused by fieldValidation. (Only the deep cloning of values can solve.)
            nesProp.set(formInputs, formFieldName, formField)
        })

        // reset the flag of form validity
        this.setFormValidityFlag()

        return formInputs
    }

    /**
     *
     * @param {*} e
     * @returns
     */
    async goToStep2(e) {
        try {
            const { onConfirmation, dispatch, client, contracts } = this.props
            let { formInputs, contractsNumberHashmap, selectedDsDocumentIds, dsPackage } = this.state

            const data = this.fetchFormValues()
            formInputs = this.setFormInputsByFormValues(data, formInputs)
            let forceTouch = true
            formInputs = this.formInputsValidation(formInputs, forceTouch)

            let isValidTheForm = this.setFormValidityFlag()
            this.setState({ formInputs: formInputs })

            // form validation can  prevent to step the wizard forward
            if (!isValidTheForm) {
                this.setState({ isLoaded: true })
                return
            }

            if (dsPackage && (!selectedDsDocumentIds || selectedDsDocumentIds.length === 0)) {
                this.setState({ isLoaded: true, wizardError: 'noDocumentSelected' })
                return
            }
            // // TODO get contractId by contract number and pass it forward for update.
            let contractNumber = nesProp.get(formInputs, "contractNumber.value")
            let contractId = contractsNumberHashmap[contractNumber]

            if (dsPackage && selectedDsDocumentIds) {
                const updates = { contractNumber, contractId }
                const updatedDocumentsResponse = await dispatch(updateManyDocuments(selectedDsDocumentIds, updates))
                if (updatedDocumentsResponse) {
                    // update package data with the new documents and set data for step 2
                    const getPackageRequestResponse = await dispatch(getOneDsPackageById(dsPackage._id))
                    if (getOneDsPackageById) {
                        const linkedDocuments = getPackageRequestResponse.dsDocuments.map(oneDoc => selectedDsDocumentIds.includes(oneDoc._id.toString()) && oneDoc)
                        this.setState({ dsPackage: getPackageRequestResponse, isLoaded: true, wizardError: false, step: 2, linkedDocuments: linkedDocuments })
                    }
                }
            }
        } catch (error) {
            console.warn(error);
            return this.setState({
                isLoaded: true,
                wizardError: (error && error.message || JSON.stringify(error)),
                step: 2
            })
        }

    }

    /**
     * This function will find in the result of document upload a dsDocument instance by ID from the list by parsing it.
     * @param {*} id
     * @param {*} dataAndDocs
     * @returns
     */
    findADocumentInListOfDocuments(documentId, dataAndDocs) {
        // check params
        if (!dataAndDocs || dataAndDocs.length == 0 || !documentId) {
            return false
        }

        // find the doc in list
        let resultDoc = false
        dataAndDocs.forEach(oneData => {
            if (oneData.dsDocument._id == documentId) {
                resultDoc = oneData.dsDocument
            }
        })

        return resultDoc
    }

    /**
     *
     * @param {*} e
     * @returns
     */
    async goToStep3(e) {
        const { dispatch } = this.props
        let { dsPackage } = this.state

        if (!dsPackage._id) {
            return Promise.reject("Missing package id")
        }

        this.setState({ isLoaded: false })
        try {
            const uploadRequestResponse = await dispatch(uploadReadyDocuments(dsPackage._id))
            if ((uploadRequestResponse && uploadRequestResponse.error) || !uploadRequestResponse) {
                throw uploadRequestResponse
            }
            if (uploadReadyDocuments) {
                const getPackageRequestResponse = await dispatch(getOneDsPackageById(dsPackage._id))
                if (getOneDsPackageById) {
                    this.setState({ dsPackage: getPackageRequestResponse, isLoaded: true, wizardError: false, step: 3 })
                }
            }
        } catch (error) {
            let errorMessageToRender = (error && error.statusText && _(error.statusText) ||
                error && error.message || JSON.stringify(error))

            let errorCode = error && error.statusText || ''

            switch (errorCode) {
                case CONNECTIVE_ERROR: {
                    errorMessageToRender = _('errorRetrievingDocumentFromConnective')
                    break
                }
                case NO_DOCUMENT_FOUND_ON_SERVER: {
                    errorMessageToRender = _('documentNotFoundToUpload')
                    break
                }
                case NO_DOCUMENTS_AVAILABLE_FOR_PROCESS: {
                    errorMessageToRender = _('documentNotReadyOrAlreadyUploaded')
                    break
                }
                case UPLOAD_TO_ORACLE_TIMEOUT: {
                    errorMessageToRender = _('canNotTransferTheDocumentToWillemot')
                    break
                }
                case NO_DOCUMENT_MATCH_FOR_UPLOAD: {
                    errorMessageToRender = _('documentNotReadyOrAlreadyUploaded')
                    break
                }
                case MISSING_ARGUMENTS: {
                    errorMessageToRender = _('missingArgumentsError')
                    break
                }
            }

            return this.setState({
                isLoaded: true,
                wizardError: errorMessageToRender,
                step: 3
            })
        }
    }

    /**
     * Handle Ui event for header checkbox
     */
    handleCheckAll() {
        const { dsDocumentsThatRequireLinking, selectedDsDocumentIds } = this.state
        const selection = selectedDsDocumentIds.length === dsDocumentsThatRequireLinking.length ? [] : dsDocumentsThatRequireLinking.map(oneDocument => oneDocument._id)
        this.setState({ selectedDsDocumentIds: selection })
    }

    /**
    * Handle Ui event for individual checkbox
    * @param {*} ev
    * @param {*} documentId
    */
    onCheckChange(ev, document) {
        const { selectedDsDocumentIds } = this.state
        const index = selectedDsDocumentIds.findIndex(oneDoc => oneDoc.toString() === document._id.toString())
        if (index >= 0) {
            selectedDsDocumentIds.splice(index, 1)
        } else {
            selectedDsDocumentIds.push(document._id)
        }
        this.setState({ selectedDsDocumentIds })
    }

    async openPdf(_id) {
        let linkForPdfDownload = HALF_FILLED_PDF_API_URL + "/" + _id
        let w = window.open(linkForPdfDownload , '_blank', 'noopener,noreferrer')

        let onLoadWindowPromise = new Promise((resolve) => {
            w.addEventListener('load', ()=>{
                resolve()
            }, true)
        })

        await onLoadWindowPromise()

        return
    }

    /**
     * Thi is the wizard step 1 content interface
     * @returns
     */
    renderStep1(message) {
        const { formInputs, contractNumbersOptions, dsDocumentsThatRequireLinking, selectedDsDocumentIds } = this.state
        const { lang } = this.props
        const allSelected = dsDocumentsThatRequireLinking && selectedDsDocumentIds && dsDocumentsThatRequireLinking.length === selectedDsDocumentIds.length

        return <div className={styles.content}>
            {message}
            {dsDocumentsThatRequireLinking && <div>
                <Table
                    filterable={[
                        "documentName"
                    ]}
                    ref={el => { this.table = el }}
                    id="table"
                    className="table"
                    sortable={[
                        { column: 'ticketDate', sortFunction: 'Date' },
                        'ticketDescription',
                        'ticketType',
                    ]}
                    defaultSort={{
                        column: 'ticketDate',
                        direction: 'desc',
                    }}

                    itemsPerPage={50}
                    pageButtonLimit={5}
                >
                    <Thead>
                        <Th column="checkbox">
                            <input
                                type="checkbox"
                                checked={allSelected}
                                onChange={() => this.handleCheckAll()}
                            />
                        </Th>
                        <Th column="pdfIcon">{" "}</Th>
                        <Th column="documentName">
                            <strong>{_("documentName")}</strong>
                        </Th>
                    </Thead>
                    {dsDocumentsThatRequireLinking && dsDocumentsThatRequireLinking.length && dsDocumentsThatRequireLinking.length > 0 ?
                        dsDocumentsThatRequireLinking.map((item, key) =>
                            <Tr
                                className={`clickable`}
                                i={item}
                                key={key}
                            >
                                <Td column="checkbox" >
                                    <div style={{ width: 15 }}>
                                        <input
                                            type="checkbox"
                                            onClick={ev => ev.stopPropagation()}
                                            onChange={ev => this.onCheckChange(ev, item)}
                                            checked={selectedDsDocumentIds.find(oneDocId => oneDocId.toString() === item._id.toString()) ? true : false}
                                        />
                                    </div>
                                </Td>
                                <Td column="pdfIcon" >
                                    <img
                                        src={require('resources/images/pdf-icon_1x.png')}
                                        onClick={() => this.openPdf(item._id)}
                                        className={styles.pdfIcon}
                                    />
                                </Td>
                                <Td column="documentName" value={item.fileName}>{item.fileName}</Td>
                            </Tr>
                        ) : ''
                    }
                </Table>
            </div>}
            <div className={styles.formInputContainer}>
                <label className={styles.formLabel}>{_('contractNumber')}:* </label>
                <div className={cs(styles.formInput, styles.formInputCreatableSelect)}>
                    <CustomSelect
                        value={this.findItemByValueFromSelectOptions(nesProp.get(formInputs, "contractNumber.value"), contractNumbersOptions)}
                        ref="contractNumber"
                        name="contractNumber"
                        onChange={(value) => {
                            return this.onChangeFormInput(
                                nesProp.get(value, "value") || "", "contractNumber"
                            )
                        }}
                        handleOnBlur={(e) => {
                            let forceTouch = true
                            let typedValue = nesProp.get(e, "target.value")

                            if (typedValue) {
                                return this.onChangeFormInput(
                                    nesProp.get(e, "target.value") || "", "contractNumber", forceTouch
                                )
                            }
                        }}
                        options={contractNumbersOptions}
                        isSearchable
                        isClearable
                        isMulti={false}
                    />

                </div>
            </div>
            <div className={cs(styles.errorMessageContainer,
                (nesProp.get(formInputs, "contractNumber.touched") && nesProp.get(formInputs, "contractNumber.error")) ? "" : styles.none
            )}>
                <div className={styles.errorMessage}>
                    {nesProp.get(formInputs, "contractNumber.error") && nesProp.get(formInputs, "contractNumber.touched") &&
                        nesProp.get(formInputs, "contractNumber.error")}
                </div>
            </div>
        </div>
    }

    /**
     * This function helps to use an icon on a safe way
     */
    getIcon(icon) {
        try {
            return require(`resources/images/${icon}.svg`)
        } catch (err) {
            return require(`resources/images/icn-no-result.svg`)
        }
    }

    /**
     * Thi is the wizard step 2 content interface
     * @param {*} canNotBeUploaded
     * @returns
     */
    renderStep2(canNotBeUploaded = false) {
        const { dsPackage, linkedDocuments } = this.state

        if (!dsPackage || !dsPackage.dsDocuments) {
            return (<div>...</div>)
        }

        return <div className={styles.content}>
            {linkedDocuments.map((oneLinkedDoc, key) => {
                return oneLinkedDoc && oneLinkedDoc._id && (
                    <div key={'linkedDocumentName' + key} className={styles.documentRow}>
                        <div className={styles.documentColumn}>
                            <img className={cs(styles.emailButtonIcon)} src={this.getIcon("n-contracts_2x.png")} />
                        </div>
                        <div className={styles.documentColumn}>
                            <div>
                                {_("documentName")}: {oneLinkedDoc.fileName || '-'}
                            </div>
                        </div>
                    </div>
                )
            })}

            {linkedDocuments && linkedDocuments.length > 0 && _("dsDocumentIsLinkedSuccessfully")}
            {canNotBeUploaded ? _("theDocumentIsNotReadyForUploadYet") : _("goToNextStepToUpload")}
        </div>
    }

    /**
     * This is the wizard step 3 content interface
     * this will list the upload status for package documents
     * @returns
     */
    renderStep3() {
        const { dsPackage, linkedDocuments } = this.state
        if (!dsPackage) {
            return (<div>...</div>)
        }

        return (
            <div >
                {dsPackage.dsDocuments.map(oneDoc => {
                    return (
                        <div className={styles.content}>
                            <div className={styles.documentRow}>
                                <div className={styles.documentColumn}>
                                    <img className={cs(styles.emailButtonIcon)} src={this.getIcon("n-contracts_2x.png")} />
                                </div>
                                <div className={styles.documentColumn}>
                                    {_("documentName")}: {oneDoc.fileName}
                                </div>
                            </div>
                            {_("dsDocumentPackageUpdated")}
                            {
                                oneDoc.uploadedToOracle ?
                                    _("dsDocumentUploaded")
                                    :
                                    _("dsDocumentNotUploaded")
                            }
                        </div>
                    )
                })}
            </div>
        )
    }

    /**
     * On click next button in the wizard
     * @param {*} e
     * @param {Boolean} closeModal
     * @param {Boolean} canBeUploaded
     */
    async onClickNext(e, closeModal, canBeUploaded) {
        const { step } = this.state
        const { onConfirmation } = this.props

        if (step === 1) {
            await this.goToStep2(e)
            // go forward and skip to push the upload button if one document is ready for upload is ready for upload BEWB-339
            if (canBeUploaded) {
                await this.goToStep3(e)
            }

        } else {
            if (step === 2) {
                // skip the upload step if the document is not ready for upload
                if (closeModal) {
                    this.clearModule()
                    onConfirmation(e)
                }

                this.goToStep3(e)
            } else {
                if (step === 3) {
                    this.clearModule()
                    onConfirmation(e)
                }
            }
        }


    }

    /**
     * this method will iterate all documents from the package and return each different upload on module
     * @returns array with each upload module present in documents list
     */
    determineModule(dsPackage) {
        // const {  } = this.props
        if (!dsPackage) {
            return
        }
        const modules = dsPackage.dsDocuments.map(oneDocument => {
            console.log('oneDocument0', oneDocument);
            return oneDocument.documentTemplate ? oneDocument.documentTemplate.uploadedOnModule : oneDocument.uploadedOnModule
        })
        //remove duplicated entries
        modules.filter((oneModule, index, originalArray) => originalArray.indexOf(oneModule) === index)
        return modules
    }

    /**
     * Check documents list if there are documents that not been uploaded
     * @returns boolean
     */
    packageHasDocumentsReadyToUpload(dsPackage) {
        // const {  } = this.props
        let hasDocsToUpload = false
        if (!dsPackage) {
            return hasDocsToUpload
        }
        dsPackage.dsDocuments.map(oneDoc => {
            if (!oneDoc.uploadedToOracle &&
                (!oneDoc.documentTemplate && oneDoc.origin === 'DS_ORIGIN_ORACLE' && dsPackage.hasFinishStatus) ||
                (oneDoc.documentTemplate && (!oneDoc.documentTemplate.mustBeSigned || (oneDoc.documentTemplate.mustBeSigned && dsPackage.hasFinishStatus)))) {
                hasDocsToUpload = true
            }
        })
        return hasDocsToUpload
    }

    render() {
        const { modalIsOpen, onCancel } = this.props
        const { step, wizardError, dsPackage } = this.state

        // determine modal title by doc template
        let title = _('documentModal')
        let message = _('linkAndUploadDescription')

        // avoid total fall in fail
        if (!dsPackage) {
            return (<div></div>)
        }

        const modules = this.determineModule(dsPackage)

        if (modules && modules.includes(c.DS_MODULE_CLIENT_CONTRACT)) {
            title = _('linkContract')
            message = _('linkContractDescription')
        }

        let mustDoUpload = this.packageHasDocumentsReadyToUpload(dsPackage)
        // in case when the doc is not signed but can be linked then we just let to connect the contract
        let skipStep2 = (step === 2 && !mustDoUpload)
        return (
            <div>
                <Modal
                    isOpen={modalIsOpen}
                    onCancel={onCancel}
                    style={customStyles}
                    className={styles.modal}
                    contentLabel={""}
                >
                    <div>
                        <div className={styles.title}>{title}</div>
                        <div className={styles.contentWrapper}>
                            {(step === 1) && this.renderStep1(message)}
                            {(step === 2) && this.renderStep2(skipStep2)}
                            {(step === 3) && this.renderStep3()}

                            {wizardError &&
                                <div className={styles.wizardError}>
                                    {_("wizardError")}
                                    {wizardError}
                                </div>
                            }

                            <div className={styles.buttons}>
                                <div
                                    onClick={() => {
                                        this.clearModule()
                                        onCancel()
                                    }}
                                    className={cs(styles.cancel)}
                                >
                                    {_('cancel')}
                                </div>

                                <div
                                    onClick={(e) => { return this.onClickNext(e, skipStep2, mustDoUpload) }}
                                    className={cs(styles.next, styles.enabled)}
                                >
                                    {(step === 1) && _("link")}
                                    {(step === 2) && (mustDoUpload && _("upload") || _("ok"))}
                                    {(step === 3) && _("done")}
                                </div>
                            </div>
                        </div>
                    </div>

                </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/DSDocuments/linkToContractAndUploadDocuments/LinkDocumentsModal.jsx